import React from "react";

export function lenderImageProps(src) {
  const base = String(src || "").replace(/\.(webp|png|jpg|jpeg)$/i, "");
  return {
    src: `${base}-224.png`,
    avifSrcSet: `${base}-224.avif 224w`,
    webpSrcSet: `${base}-224.webp 224w`,
    fallbackSrcSet: `${base}-224.png 224w`,
    sizes: "112px",
  };
}

export default function OptimizedImage({
  src,
  avifSrcSet,
  webpSrcSet,
  fallbackSrcSet,
  sizes,
  alt,
  className,
  style,
  loading = "lazy",
  decoding = "async",
  fetchPriority,
  ...rest
}) {
  return (
    <picture>
      {avifSrcSet ? <source type="image/avif" srcSet={avifSrcSet} sizes={sizes} /> : null}
      {webpSrcSet ? <source type="image/webp" srcSet={webpSrcSet} sizes={sizes} /> : null}
      <img
        src={src}
        srcSet={fallbackSrcSet}
        sizes={sizes}
        alt={alt}
        className={className}
        style={style}
        loading={loading}
        decoding={decoding}
        fetchPriority={fetchPriority}
        {...rest}
      />
    </picture>
  );
}
